if (!customElements.get('personalisation-upload')) {
  customElements.define(
    'personalisation-upload',
    class PersonalisationUpload extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.input = this.querySelector('input[type="file"]');
        this.form = this.input.form;
        this.error = this.querySelector('[role="alert"]');
        this.selection = this.querySelector('.personalisation-upload__selection');
        this.preview = this.querySelector('img');
        this.input.addEventListener('change', () => this.updatePreview(), options);
        this.querySelector('[data-remove-upload]').addEventListener('click', () => {
          this.input.value = '';
          this.updatePreview();
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          this.input.focus();
        }, options);
        this.preview.addEventListener('error', () => {
          if (!this.preview.hasAttribute('src')) return;
          this.preview.hidden = true;
          this.setError('This image could not be opened. Choose another JPG, PNG, WebP or GIF.');
        }, options);
        // Dawn's form uses novalidate, so check this field before its AJAX handler.
        this.form.addEventListener('submit', (event) => {
          if (this.input.validity.valid) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.input.reportValidity();
        }, { ...options, capture: true });
        this.form.addEventListener('formdata', (event) => {
          if (!this.input.files.length) event.formData.delete(this.input.name);
        }, options);
        this.form.addEventListener('reset', () => {
          this.input.value = '';
          this.updatePreview();
        }, options);
        this.updatePreview();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.clearPreview();
      }

      setError(message = '') {
        this.input.setCustomValidity(message);
        this.input.setAttribute('aria-invalid', String(Boolean(message)));
        this.error.textContent = message;
        this.error.hidden = !message;
      }

      clearPreview() {
        if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
        this.preview?.removeAttribute('src');
        if (this.preview) this.preview.hidden = true;
      }

      updatePreview() {
        this.clearPreview();
        this.setError();
        const file = this.input.files[0];
        this.selection.hidden = !file;
        if (!file) return;
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
        if (!/\.(jpe?g|png|webp|gif)$/i.test(file.name) || (file.type && !allowedTypes.includes(file.type))) {
          this.setError('Choose a JPG, PNG, WebP or GIF image.');
          return;
        }
        if (file.size === 0 || file.size > 10 * 1024 * 1024) {
          this.setError('Choose an image larger than 0 bytes and no more than 10 MB.');
          return;
        }
        this.previewUrl = URL.createObjectURL(file);
        this.preview.src = this.previewUrl;
        this.preview.hidden = false;
      }
    }
  );
}
